module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-non-clickable', {
    class: _vm.getClassMobile(),
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    style: (_vm.mainDivStyle())
  }, [_c('div', {
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "20px"
    }
  }, [_c('img', {
    staticClass: "modal-back-arrow",
    attrs: {
      "src": require("../assets/img/icons/arrow_left.svg")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, [_c('button', {
    staticClass: "new-button",
    staticStyle: {
      "width": "60px"
    },
    on: {
      "click": function($event) {
        _vm.amount = 10
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.addCredits ? '+' : '-') + "10 "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "2px"
    },
    attrs: {
      "src": require("../assets/img/coin.png")
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "new-button",
    staticStyle: {
      "width": "60px"
    },
    on: {
      "click": function($event) {
        _vm.amount = 50
      }
    }
  }, [_vm._v(_vm._s(_vm.addCredits ? '+' : '-') + "50 "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "2px"
    },
    attrs: {
      "src": require("../assets/img/coin.png")
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "new-button",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        _vm.amount = 100
      }
    }
  }, [_vm._v(_vm._s(_vm.addCredits ? '+' : '-') + "100 "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "2px"
    },
    attrs: {
      "src": require("../assets/img/coin.png")
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "new-button",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        _vm.amount = 200
      }
    }
  }, [_vm._v(_vm._s(_vm.addCredits ? '+' : '-') + "200 "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "2px"
    },
    attrs: {
      "src": require("../assets/img/coin.png")
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "new-button",
    staticStyle: {
      "width": "70px"
    },
    on: {
      "click": function($event) {
        _vm.amount = 500
      }
    }
  }, [_vm._v(_vm._s(_vm.addCredits ? '+' : '-') + "500 "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "2px"
    },
    attrs: {
      "src": require("../assets/img/coin.png")
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "new-button",
    staticStyle: {
      "width": "80px"
    },
    on: {
      "click": function($event) {
        _vm.amount = 1000
      }
    }
  }, [_vm._v(_vm._s(_vm.addCredits ? '+' : '-') + "1000 "), _c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "2px"
    },
    attrs: {
      "src": require("../assets/img/coin.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card ui-card form--account"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_credit_amount')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_credit_amount'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), (_vm.hasError != null && _vm.hasError.length > 0) ? _c('div', {
    staticClass: "foo",
    staticStyle: {
      "color": "red"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.hasError))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.addCredit
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_save")) + "\n              ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "50px"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7dda7a6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AddUserCredit.vue
// module id = 819
// module chunks = 0